/* tslint:disable */

declare var Object: any;
export interface ConsultasSqlInterface {
  "id"?: number;
}

export class ConsultasSql implements ConsultasSqlInterface {
  "id": number;
  constructor(data?: ConsultasSqlInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ConsultasSql`.
   */
  public static getModelName() {
    return "ConsultasSql";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ConsultasSql for dynamic purposes.
  **/
  public static factory(data: ConsultasSqlInterface): ConsultasSql{
    return new ConsultasSql(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ConsultasSql',
      plural: 'ConsultasSqls',
      path: 'ConsultasSqls',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/shared/lb-sdk/models/ConsultasSql.ts